import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/apoyo-a-la-transicion-de-mdd-a-mdr")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/apoyo-a-la-transicion-de-mdd-a-mdr"),
  component: RegulatoryOffering,
});
